import script from "./Offline.vue?vue&type=script&setup=true&lang=js"
export * from "./Offline.vue?vue&type=script&setup=true&lang=js"

import "./Offline.vue?vue&type=style&index=0&id=b9d1370a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9d1370a"]])

export default __exports__